import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "buyers-content" }
const _hoisted_3 = { class: "buyer-field" }
const _hoisted_4 = { class: "buyer-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("div", { class: "modal-title" }, "Edit Buyers")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("label", { class: "label" }, "Buyer 1", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "buyer-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.firstBuyer) = $event)),
              type: "text",
              placeholder: "Enter first buyer name"
            }, null, 512), [
              [_vModelText, $setup.firstBuyer]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "label" }, "Buyer 2", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "buyer-input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.secondBuyer) = $event)),
              type: "text",
              placeholder: "Enter second buyer name"
            }, null, 512), [
              [_vModelText, $setup.secondBuyer]
            ])
          ])
        ]),
        _createElementVNode("div", { class: "modal-actions" }, [
          _createElementVNode("button", {
            class: "btn cancel",
            onClick: $setup.close
          }, "Cancel"),
          _createElementVNode("button", {
            class: "btn primary v2",
            onClick: $setup.confirm
          }, "Save")
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}